import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row } from "reactstrap";
import { connect } from "react-redux";
import GetSettingWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetSettingWorkflowTaskService";
import UpdateTaskActiveStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskActiveStatusService";
import UpdateTaskRolesForTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskRolesForTaskService";
function WorkflowSettings(props) {
  // const [currentPhaseId, setCurrentPhaseId] = useState(props.workflowPhases && props.workflowPhases[0] ? props.workflowPhases[0].id : 0);
  const [currentPhaseId, setCurrentPhaseId] = useState(props.flag == false ? (props.workflowPhases && props.workflowPhases[0]) ? props.workflowPhases[0].id : 0 : props.selectedTask && props.selectedTask.phaseId);
  const [taskList, setTaskList] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [workflowPhaseCount, setWorkflowPhaseCount] = useState([]);
  const [totalWorkflowPhaseCount, setTotalWorkflowPhaseCount] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoding] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [changedRoles, setChangedRoles] = useState({});
  const [selectedRoleFilter, setSelectedRoleFilter] = useState("");
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  useEffect(() => {
    if (props.workflowPhases && props.workflowPhases.length > 0) {
      if (props.flag === false) {
        setCurrentPhaseId(props.workflowPhases[0].id);
      } else if (props.selectedTask && props.selectedTask.phaseId) {
        setCurrentPhaseId(props.selectedTask.phaseId);
      }
    }
  }, [props.workflowPhases, props.flag, props.selectedTask]);
  useEffect(function () {
    setLoding(true);

    var data = {
      settingsWorkflowId: props.settingsWorkflowId,
    };

    GetSettingWorkflowTaskService(props.token, data).then(function (res) {
      if (res) {
        console.log(res)
        setTaskList(res.tasklist || []);
        setAllTasks(res.tasklist || []);
        setRolesList(res.rolesList || []);
        setLoding(false);
      }
    });
  }, [props.settingsWorkflowId]);

  const handlePreviewToggle = () => {
    setIsPreviewMode((prev) => !prev);
  }
  const handleSearchInputChange = (e) => {
    var value = e.target.value;
    setSearchInput(value);
  
    // If input empty → reset data
    if (!value) {
      setTaskList(allTasks);
      return;
    }
  
    // Filter tasks
    var filtered = allTasks.filter(function (task) {
      return (task.taskText || "")
        .toLowerCase()
        .includes(value.toLowerCase());
    });
  
    setTaskList(filtered);
  
    if (filtered.length > 0) {
      setCurrentPhaseId(filtered[0].WorkflowPhases);
    }
  };

  const handleRoleChange = (taskId, value) => {
    setChangedRoles((prev) => ({
      ...prev,
      [taskId]: value,
    }));
    let data = {
      taskId: taskId,
      roleId: value,
      settingsWorkflowId: props.settingsWorkflowId
    }
    UpdateTaskRolesForTaskService(props.token, data).then((res) => {
      if (res) {
        console.log(res);
        setTaskList(res.res.tasklist);
        setAllTasks(res.res.tasklist);
        setRolesList(res.res.rolesList || []);
      }

    })
  };

  const handleActiveChange = function (task) {
    const newStatus = !task.isActive;

    var updated = taskList.map(function (t) {
      if (t.id === task.id) {
        return { ...t, isActive: newStatus };
      }
      return t;
    });
    setTaskList(updated);
    UpdateTaskActiveStatusService(props.token, {
      taskId: task.id,
      isActive: newStatus,
    }).then((res) => {
      console.log("Updated successfully", res);
    });
  };


  // const getFilteredTasks = () => {
  //   return taskList.filter(function (task) {

  //     if (isPreviewMode) {
  //       return true;
  //     }

  //     var phaseMatch =
  //       !currentPhaseId ||
  //       Number(task.WorkflowPhases) === Number(currentPhaseId);

  //     var roleMatch = true;

  //     if (selectedRoleFilter) {
  //       roleMatch =
  //         task.roleId &&
  //         Number(task.roleId) === Number(selectedRoleFilter);
  //     }

  //     return phaseMatch && roleMatch;
  //   });
  // };
  const getFilteredTasks = () => {
    return taskList.filter((task) => {
      const phaseMatch =
        isPreviewMode ||
        !currentPhaseId ||
        Number(task.WorkflowPhases) === Number(currentPhaseId);
  
      const roleMatch =
        !selectedRoleFilter ||
        Number(task.roleId) === Number(selectedRoleFilter);
  
      return phaseMatch && roleMatch;
    });
  };

  const getTasksByPhase = (phaseId) => {
    return taskList.filter(
      (task) => Number(task.WorkflowPhases) === Number(phaseId)
    );
  };
  return (
    <>
      <Card className="pr-3 pl-3 pt-1 pb-1 mb-2  card-of-problemarea mt-3">
        <Row>
          <Col md={12}>
          <Row>
            <Col md={3}>
            {/* {props.workflowMainCategory && props.workflowMainCategory.map((workMC) =>
                workMC.id == props.settingsWorkflowId ? (
                  <h5 className="mb-0 mt-2">
                    <b>{workMC.name} </b>
                  </h5>
                ) : (
                  ""
                )
              )} */}
              <div className="d-flex">
                  <label className="worflows-setting-toggle-switch w-25 mb-0">
                    <input
                      type="checkbox"
                      className="d-none"
                      checked={isPreviewMode}
                      onChange={handlePreviewToggle}
                    />
                    <span className="worflows-setting-dot"></span>
                  </label>

                  <span className="mt-1">Preview All Tasks</span>

                </div>
            </Col>
            <Col md={9} className='d-flex justify-content-end'>
              {/* <select
                className="form-control w-25 ml-2 mr-2"
                value={selectedRoleFilter}
                onChange={(e) => setSelectedRoleFilter(e.target.value)}
              >
                <option value="">--All Roles--</option>

                {rolesList.map((role) => (
                  <option key={role.id} value={role.id.toString()}>
                    {role.role}
                  </option>
                ))}
              </select> */}

              <Input
                type="text"
                value={searchInput}
                disabled={loading ? true : false}
                onChange={(e) => handleSearchInputChange(e)}
                className="form-control w-25"
                placeholder="Search Tasks "
              />
            </Col>
          </Row>
          </Col>

          <Col md={12} className="p-2">
            {isPreviewMode ?

              <div className="d-flex ml-2">
                <>
                  {props.workflowPhases
                    ? props.workflowPhases.map((phase) => (
                      <>
                        {props.selectedWorkflowMasterId ==
                          phase.WorkflowsMaster ? (
                          <div
                            className="selected-tab-workflows-previewmode m-2"
                          >
                            <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                              <b>{phase.name}</b>
                            </p>
                            {workflowPhaseCount
                              && workflowPhaseCount.map((count) => (
                                <p className="text-center p-0 mb-0 mr-2">
                                  {phase.id === count.WorkflowPhases_id
                                    ? count.attemptedTaskCount +
                                    " of " +
                                    count.taskCount +
                                    " Completed"
                                    : ""}
                                </p>
                              ))
                            }
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ))
                    : ""}
                </>
              </div> :
              <div className="d-flex">
                <>

                  {props.workflowPhases
                    ? props.workflowPhases.map((phase) => (
                      <>
                        <div
                          onClick={() => {
                            if (!loading) {
                              setCurrentPhaseId(phase.id);
                            }
                          }}
                          style={{
                            cursor: loading ? "not-allowed" : "pointer",
                            opacity: loading ? 0.5 : 1
                          }}
                          className={
                            phase.id == currentPhaseId
                              ? "selected-tab-workflows m-2"
                              : "pt-3 pb-3 m-2"
                          }
                        >
                          <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                            <b>{phase.name}</b>
                          </p>
                          {workflowPhaseCount
                            && workflowPhaseCount.map((count) => (
                              <p className="text-center p-0 mb-0">
                                {phase.id === count.WorkflowPhases_id
                                  ? count.attemptedTaskCount +
                                  " of " +
                                  count.taskCount +
                                  " Completed"
                                  : ""}
                              </p>
                            ))
                          }

                        </div>
                      </>
                    ))
                    : ""}
                </>
              </div>
            }

          </Col>
        </Row>
      </Card>
      <>

        <Card>
          <Col md={12} className='pb-4'>
            <table className="table">
              <thead>
                <tr>
                  <th> Task</th>
                  <th>Role</th>
                  <th style={{ textAlign: "center" }}>Active</th>
                </tr>
              </thead>

              {/* <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <b>Loading task data...</b>
                    </td>
                  </tr>
                ) : taskList && taskList.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : (
                    getFilteredTasks().map(function (task) {
                      const currentValue =
                        changedRoles[task.id] !== undefined
                          ? changedRoles[task.id]
                          : task.roleId;
                      return (
                        <tr key={task.id}>
                          <td style={{ width: "40%" }}>
                            {task.taskText}
                          </td>

                          <td style={{ width: "30%" }}>
                            {isPreviewMode?
                            <p className="mb-0">{task.roleName}</p>:
                            <select
                              className="form-control w-75"
                              value={currentValue ? currentValue.toString() : ""}
                              onChange={(e) => handleRoleChange(task.id, e.target.value)}
                            >
                              <option value="">--Select Role--</option>

                              {rolesList.map((role) => (
                                <option key={role.id} value={role.id.toString()}>
                                  {role.role}
                                </option>
                              ))}
                            </select>}
                            
                          </td>

                          <td style={{ width: "30%" }}>
                            <input
                            disabled={isPreviewMode}
                              type="checkbox"
                              checked={task.isActive || false}
                              onChange={function () {
                                handleActiveChange(task);
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })
                )}
              </tbody> */}
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <b>Loading task data...</b>
                    </td>
                  </tr>
                ) : taskList.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : isPreviewMode ? (
                
                  props.workflowPhases.map((phase) => {

                    const phaseTasks = getFilteredTasks().filter(
                      (task) => Number(task.WorkflowPhases) === Number(phase.id)
                    );

                    if (!phaseTasks.length) return null;

                    return (
                      <React.Fragment key={phase.id}>
                        <tr style={{ background: "#f5f5f5" }}>
                          <td colSpan="3">
                            <b>{phase.name}</b>
                          </td>
                        </tr>

                        {phaseTasks.map((task) => {
                          const currentValue =
                            changedRoles[task.id] !== undefined
                              ? changedRoles[task.id]
                              : task.roleId;

                          return (
                            <tr key={task.id}>
                              <td>{task.taskText}</td>

                              <td>
                                <p className="mb-0">{task.roleName}</p>
                              </td>

                              <td>
                                <input
                                  disabled
                                  type="checkbox"
                                  checked={task.isActive || false}
                                  readOnly
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })
                ) : (
                  getFilteredTasks().map((task) => {
                    const currentValue =
                      changedRoles[task.id] !== undefined
                        ? changedRoles[task.id]
                        : task.roleId;

                    return (
                      <tr key={task.id}>
                        <td>{task.taskText}</td>

                        <td>
                          <select
                            className="form-control w-75"
                            value={currentValue ? currentValue.toString() : ""}
                            onChange={(e) =>
                              handleRoleChange(task.id, e.target.value)
                            }
                          >
                            <option value="">--Select Role--</option>
                            {rolesList.map((role) => (
                              <option key={role.id} value={role.id.toString()}>
                                {role.role}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={task.isActive || false}
                            onChange={() => handleActiveChange(task)}
                          />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </Col>
        </Card>
      </>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(WorkflowSettings);
